import * as TYPE from '../types';
import { defaultEntities } from './init';

export const entities = (state = defaultEntities, action) => {
  switch (action.type) {
    case TYPE.UPDATE_ENTITIES:
      return { ...state, entities: action.entities };
    case TYPE.TOGGLE_BY_TEAM_CHECKBOX:
      return { ...state, byTeam: action.toggle };
    case TYPE.CLEAN_ENTITIES_STATE:
      return defaultEntities;
    default:
      return state;
  }
};
